/* global AFRAME */

AFRAME.registerComponent('set-video', {
  schema: {
    on: {type: 'string'},
    target: {type: 'selector'},
    src: {type: 'string'},
    dur: {type: 'number', default: 400}
  },

  init: function() {
    var data = this.data;
    var el = this.el;
    var self = this;

    this.setupFadeAnimation();
    this.setupVideos();

    el.addEventListener(data.on, () => {
      data.target.emit('set-video-fade');

      setTimeout(() => {
        data.target.setAttribute('src', data.src);

        var video = document.querySelector(data.src);
        video.muted = false;
        video.setAttribute('muted', false);

        if (video.paused && !video.isplaying) {
          video.currentTime = 0;
          var playPromise = video.play();
          if (playPromise) {
            playPromise.then(() => {
              video.isplaying = true;
              video.ispaused = false;
              document.querySelector("#play-button").emit('fade-out');
              document.querySelector("#pause-button").emit('fade-in');
            }).catch((error) => {
              video.isplaying = false;
              video.ispaused = true;
              document.querySelector("#play-button").emit('fade-in');
              document.querySelector("#pause-button").emit('fade-out');
              console.log('Error in set ' + error);
            });
          }
        }
      }, data.dur);
    });
  },

  /**
   * Setup fade-in + fade-out.
   */
  setupFadeAnimation: function() {
    var data = this.data;
    var targetEl = this.data.target;

    if (targetEl.dataset.setImageFadeInFadeout) {
      return;
    }

    targetEl.dataset.setImageFadeInFadeout = true;

    targetEl.setAttribute('animation__fade', {
      property: 'material.color',
      dir: 'alternate',
      startEvents: 'set-video-fade',
      dur: data.dur,
      from: '#FFF',
      to: '#000'
    });
  },

  // Reference: http://stackoverflow.com/questions/36803176/how-to-prevent-the-play-request-was-interrupted-by-a-call-to-pause-error
  setupVideos: function() {
    var videos = document.getElementsByTagName('video');

    for(var i = 0; i<videos.length; i++) {
      var video = videos[i];

      video.onplaying = (event) => {
        event.target.isplaying = true;
        event.target.ispaused = false;
      };

      video.onpause = (event) => {
        event.target.isplaying = false;
        event.target.ispaused = true;
      };

      video.onended = (event) => {
        const pieces = document.querySelectorAll('.room-piece');
        const cursor = document.querySelector('#cursor');
        const playerButtons = document.querySelectorAll('.player-button');

        for(var i = 0; i<playerButtons.length; i++) {
          const element = playerButtons[i];
          element.emit('fade-out');
        }

        for(var i = 0; i<pieces.length; i++) {
          const element = pieces[i];
          element.emit('fade-in');
        }

        cursor.emit('toggle-size', null, true);
        cursor.setAttribute('raycaster', 'objects', '.link');
      }
    }
  }
});



// WEBPACK FOOTER //
// ./js/components/set-video.js